import BellaGaTracking from 'Common/ga';

const owwUrlRedirectTracking = (gaTracking: BellaGaTracking, location: Location) => {
    const params = new URLSearchParams(location.search);
    if (params.get('oww_redirect') === '1') {
        gaTracking.trackGenericEvent('Redirect', {
            action: 'WestwingNow',
            label: location.href,
        });
    }
};

export default owwUrlRedirectTracking;
